import { CtaButton } from "./CTA";
import { useDownload } from "@/hooks/useDownload";

export const AppDownloadButton = ({ label = "Download the app", source, plan, variant = "primary", testId, className = "" }) => {
  const download = useDownload();
  return (
    <CtaButton
      variant={variant}
      data-testid={testId}
      className={className}
      onClick={() => download({ source, plan })}
    >
      {label}
    </CtaButton>
  );
};
